import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import routes from "routes";
import { RoutesType } from "types/globalTypes";

export default function ResponderLayout(props: { [x: string]: any }) {
  const { ...rest } = props;
  const location = useLocation();

  React.useEffect(() => {}, [location.pathname]);

  const getActiveNavbar = (routes: RoutesType[]): string | boolean => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };

  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((route, key) => {
      if (route.layout !== "/assessment") return null;

      return (
        <React.Fragment key={key}>
          {/* parent route */}
          <Route path={`/${route.path}`} element={route.component} />

          {/* children routes */}
          {route.children?.map((child, childKey) => (
            <Route
              key={`${key}-${childKey}`}
              path={`/${child.path}`}
              element={child.component}
            />
          ))}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="flex min-h-screen w-full">
      {/* Navbar & Main Content */}
      <div className="min-h-screen w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main className={`mx-[12px] min-h-screen transition-all`}>
          {/* Routes */}
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => {}}
              secondary={getActiveNavbar(routes)}
              showProfile={false}
              {...rest}
            />
            <div className="m-auto h-full min-h-[87vh] p-2 pt-5">
              <Routes>
                {getRoutes(routes)}

                <Route
                  path="/"
                  element={<Navigate to="/assessment" replace />}
                />
              </Routes>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
